import theme from "@/theme";
import { SVGProps } from "react";
const QuestionCircleSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.999 13.5V12a2 2 0 1 0-2.001-2"
    />
    <circle
      cx={12}
      cy={12}
      r={9.004}
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.998 15.952a.05.05 0 1 0 0 .1.05.05 0 0 0 0-.1"
    />
  </svg>
);
export default QuestionCircleSvg;
